<template>
<div class="modal-card" style="width: auto">
  <header class="modal-card-head">
    <p class="modal-card-title">Tracing</p>
  </header>

  <P5 v-bind:sensorData="rtcData">
  </P5>

  <section class="modal-card-body">

    <div v-for="(data, peer) in rtcData" :key="peer">
      <ul>
        <li> Peer: {{ peer }}
          <ul><li> {{ data }} </li></ul>
        </li>
      </ul>
    </div>

      <!-- This is limiting webrtc to component instances -->
    <WebRTC
      key="mobile"
      ref="rtc"
      v-bind:rtcDebug="rtcDebug"
      v-on:rtc_open="onRTCOpen"
      v-on:rtc_close="onRTCClose"
      v-on:rtc_message="onRTCMessage">
    </WebRTC>
  </section>

  <footer class="modal-card-foot">
    <b-button
      size="is-large"
      v-on:click="cancel()">
      Cancel
    </b-button>

    <b-button
      size="is-large"
      v-on:click="save()">
      Save
    </b-button>

  </footer>
</div>

</template>

<script>
import { mapState } from 'vuex'
import Trace from '@/models/Trace'
import api from '@/utils/api'
import WebRTC from '@/components/WebRTC'
import P5 from '@/components/P5'

var traceData = []

export default {
  components: {
    P5,
    WebRTC
  },
  props: {
    trace: {
      type: Trace,
      required: true
    }
  },
  data () {
    return {
      rtcDebug: true,
      rtcData: {},
      closing: false
    }
  },
  computed: {
    ...mapState({
      wsMessage: state => state.websocket.message
    })
  },
  methods: {
    onRTCOpen (peer) {
      console.log('inRTCOpen', peer)
      // Use channel name so the same user can be distinguished if
      // they are logged in from multiple devices.
      this.$set(
        this.rtcData,
        peer.channel_name,
        {}
      )
    },
    onRTCClose (peer) {
      console.log('onRTCClose', peer)
      if (!this.closing) {
        this.$delete(this.rtcData, peer.channel_name)
      }
    },
    onRTCMessage (data) {
      // console.log('onRTCMessage', data)

      this.$set(
        this.rtcData[data.from.channel_name],
        data.type,
        data.sensorData
      )
      // console.log(data)
      // FIXME: Start/stop recording separately
      traceData.push(data)

      // Broadcast to all other peers.
      this.$refs.rtc.sendJson(
        data,
        data.from.channel_name
      )
    },
    save () {
      // console.log('save', this.trace, traceData)
      this.closing = true
      api.updateTrace(this.trace, {
        data: traceData
      })
      this.$refs.rtc.close()
      this.$emit('save', this)
      this.$parent.close()
    },
    cancel () {
      console.log('cancel record')
      this.closing = true
      this.$refs.rtc.close()
      this.$emit('abort', this)
      this.$parent.close()
    }
  },
  beforeDestroy () {
    if (!this.closing) {
      this.cancel()
    }
  }
}
</script>
